module.exports = __webpack_public_path__ + "img/guangfu.da88cb30.png";